const Q = require(`q`);
const __request = require(`./__request/__request_contentType_form`);
//分销商搜索
// 接口文档地址：http://219.128.52.2:9999/doc.html#/yinzhilv_travel/user-buyer-controller/travelProductSearchUsingPOST
const web_common_userBuyer_ediTravelSearch = (pParameter) => {
  if (!pParameter) pParameter = {};
  const p = {
    method: 'post',
    urlSuffix: '/web/common/userBuyer/ediTravelSearch',
    data: pParameter,
  };
  return Q.when()
    .then(function () {
      return __request(p);
    })
    .then(function (data) {
      return Q.resolve(data);
    })
    .catch(function (ex) {
      console.error(ex);
      if (ex) {
        if (ex.stack) {
          console.error(ex.stack);
        }
      }
      return Q.reject(ex);
    });

};
module.exports = web_common_userBuyer_ediTravelSearch;
